import { useState } from "react";
import "../../styles/common/registration-form.css";
import InputField from "../common/components/InputField";
import CheckboxGroup from "../common/components/CheckboxGroup";
import AgreementCheckbox from "../common/components/AgreementCheckbox";
import { validateFormData } from "../../utils/validateRegistrationForm";
import { sendRegistrationEmail } from "../../services/emailService";

const programOptions = ["Mỹ thuật thiếu nhi", "Lập trình thiếu nhi"];
const educationOptions = [
  { value: "Trung cấp", label: "Trung cấp" },
  { value: "Cao đẳng", label: "Cao đẳng" },
  { value: "Đại học", label: "Đại học" },
  { value: "Khác", label: "Khác" },
];
const sourceOptions = [
  {
    value: "Website: www.design24.edu.vn",
    label: "Website: www.design24.edu.vn",
  },
  { value: "Fanpage: Học viện Design24", label: "Fanpage: Học viện Design24" },
  { value: "Bạn bè/Giới thiệu", label: "Bạn bè/Giới thiệu" },
  { value: "Quảng cáo", label: "Quảng cáo" },
  { value: "Khác", label: "Khác" },
];

const RegistrationForm = ({ showToast }) => {
  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    email: "",
    programs: [],
    education: "Trung cấp",
    otherEducation: "",
    address: "",
    source: "Website: www.design24.edu.vn",
    otherSource: "",
    message: "",
    agreement: false,
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => {
      if (type === "checkbox") {
        if (name === "agreement") {
          return { ...prev, [name]: checked };
        } else {
          const newPrograms = checked
            ? [...prev.programs, value]
            : prev.programs.filter((p) => p !== value);
          return { ...prev, programs: newPrograms };
        }
      }
      return { ...prev, [name]: value };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validateFormData(formData);
    if (Object.keys(validationErrors).length === 0) {
      sendRegistrationEmail(formData)
        .then(() => {
          showToast(
            "Gửi đăng ký thành công! Chúng tôi sẽ liên hệ sớm.",
            "success"
          );
          setFormData({
            fullName: "",
            phone: "",
            email: "",
            programs: [],
            education: "Trung cấp",
            otherEducation: "",
            address: "",
            source: "Website: www.design24.edu.vn",
            otherSource: "",
            message: "",
            agreement: false,
          });
          setErrors({});
        })
        .catch(() => {
          showToast("Gửi đăng ký thất bại, vui lòng thử lại!", "error");
        });
    } else {
      setErrors(validationErrors);
      showToast("Vui lòng kiểm tra lại các trường thông tin.", "error");
    }
  };

  return (
    <div className="registration-form-bg">
      <div className="registration-form">
        <div className="registration-form__title-container">
          <h1
            id="registration-form"
            className="registration-form__title"
          >
            ĐĂNG KÝ THAM GIA <br />
            <span className="highlighted">
              Chương trình mỹ thuật và lập trình
            </span>
          </h1>
          <p className="registration-form__subtitle">TẠI HỌC VIỆN DESIGN24</p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="registration-form__form"
        >
          <InputField
            id="fullName"
            label="Họ và tên"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            error={errors.fullName}
            placeholder="Nguyễn Văn A"
            required
          />

          <InputField
            id="phone"
            label="Số điện thoại"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            error={errors.phone}
            placeholder="034 432 7071"
            required
          />

          <InputField
            id="email"
            label="Email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            error={errors.email}
            placeholder="nguyenvana@gmail.com"
            required
          />

          <CheckboxGroup
            options={programOptions}
            name="programs"
            selectedValues={formData.programs}
            onChange={handleChange}
            error={errors.programs}
          />

          <InputField
            id="education"
            label="Trình độ học vấn hiện tại"
            name="education"
            value={formData.education}
            onChange={handleChange}
            options={educationOptions}
            className="registration-form__field--select"
          />

          {formData.education === "Khác" && (
            <InputField
              id="other-education"
              label="Trình độ học vấn (khác)"
              name="otherEducation"
              value={formData.otherEducation}
              onChange={handleChange}
              error={errors.otherEducation}
              placeholder="Nhập trình độ học vấn"
              required
            />
          )}

          <InputField
            id="address"
            label="Nơi ở hiện tại"
            name="address"
            value={formData.address}
            onChange={handleChange}
            placeholder="Ninh Kiều, TP Cần Thơ"
          />

          <InputField
            id="source"
            label="Nguồn thông tin biết đến chương trình"
            name="source"
            value={formData.source}
            onChange={handleChange}
            options={sourceOptions}
            className="registration-form__field--select"
          />

          {formData.source === "Khác" && (
            <InputField
              id="other-source"
              label="Nguồn thông tin (khác)"
              name="otherSource"
              value={formData.otherSource}
              onChange={handleChange}
              error={errors.otherSource}
              placeholder="Nhập nguồn thông tin khác"
              required
            />
          )}

          <InputField
            id="message"
            label="Lời nhắn hoặc câu hỏi (nếu có)"
            name="message"
            value={formData.message}
            onChange={handleChange}
            textarea
          />

          <AgreementCheckbox
            checked={formData.agreement}
            onChange={handleChange}
            error={errors.agreement}
          />

          <div className="registration-form__field">
            <button
              type="submit"
              className="registration-form__submit-button"
            >
              GỬI ĐĂNG KÝ
            </button>
          </div>
        </form>

        <div className="registration-form__footer">
          <p>
            Hotline tư vấn & hỗ trợ: <a href="tel:0704888009">0704 888 009</a> -{" "}
            <a href="tel:0784888009">0784 888 009</a>
          </p>
          <p>
            Địa chỉ: 166 Nguyễn Văn Cừ, P. An Bình, Q. Ninh Kiều, TP. Cần Thơ,
            Việt Nam
          </p>
          <p>
            Website:{" "}
            <a
              href="https://www.design24.edu.vn"
              target="_blank"
              rel="noopener noreferrer"
            >
              www.design24.edu.vn
            </a>{" "}
            | Fanpage:{" "}
            <a
              href="https://www.facebook.com/www.design24.edu.vn"
              target="_blank"
              rel="noopener noreferrer"
            >
              Học viện Design24
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegistrationForm;
